<template>
  <div class="main-content">
        <div class="page-title">
            <h1>AI数字资产确权中心</h1>
            <p>AI DIGITAL ASSET TITLE CONFIRMATION CENTER</p>
        </div>

        <div class="success-icon">
            <img src="../../assets/shenhe@2x.png" alt="核验通过">
        </div>

        <div class="success-text">核验通过</div>
        

        <div class="certificate-card">
            <div class="certificate-header">
            <img src="../../assets/biaoti@2x.png" alt="证书头部">
            <!-- <div class="certificate-header-text">Ai数字资产确权证书信息</div> -->
        </div>
            <div class="info-item">
                <div class="info-label">
                    <img src="../../assets/biaoqian1@2x.png" alt="箭头">
                    确权ID
                </div>
                <div class="info-value">{{ certInfo.id || '-' }}</div>
            </div>

            <div class="info-item">
                <div class="info-label">
                    <img src="../../assets/biaoqian1@2x.png" alt="箭头">
                    确权名称
                </div>
                <div class="info-value">{{ certInfo.name || '-' }}</div>
            </div>

            <div class="info-item">
                <div class="info-label">
                    <img src="../../assets/biaoqian1@2x.png" alt="箭头">
                    数据类别
                </div>
                <div class="info-value">{{ certInfo.type || '-' }}</div>
            </div>

            <div class="info-item">
                <div class="info-label">
                    <img src="../../assets/biaoqian1@2x.png" alt="箭头">
                    登记主体
                </div>
                <div class="info-value">{{ certInfo.zhuti || '-' }}</div>
            </div>

            <div class="info-item">
                <div class="info-label">
                    <img src="../../assets/biaoqian1@2x.png" alt="箭头">
                    统一社会信用代码
                </div>
                <div class="info-value">{{ certInfo.cid || '-' }}</div>
            </div>

            <div class="info-item">
                <div class="info-label">
                    <img src="../../assets/biaoqian1@2x.png" alt="箭头">
                    确权类型
                </div>
                <div class="info-value">{{ certInfo.qq_type || '-' }}</div>
            </div>

            <div class="info-item">
                <div class="info-label">
                    <img src="../../assets/biaoqian1@2x.png" alt="箭头">
                    确权期限
                </div>
                <div class="info-value">{{ certInfo.qq_time || '-' }}</div>
            </div>

            <div class="info-item">
                <div class="info-label">
                    <img src="../../assets/biaoqian1@2x.png" alt="箭头">
                    确权担保状态
                </div>
                <div class="info-value">{{ certInfo.status || '-' }}</div>
            </div>

            <div class="info-item">
                <div class="info-label">
                    <img src="../../assets/biaoqian1@2x.png" alt="箭头">
                    上链hash值
                </div>
                <div class="info-value">{{ certInfo.hash || '-' }}</div>
            </div>

            <div class="info-item">
                <div class="info-label">
                    <img src="../../assets/biaoqian1@2x.png" alt="箭头">
                    确权有效期
                </div>
                <div class="info-value">{{ certInfo.time || '-' }}</div>
            </div>
        </div>

        <div class="disclaimer-section">
            <div class="disclaimer-title">
                <!-- <img src="img/biaoqian2@2x.png" alt="装饰"> -->
                免责声明
                <!-- <img src="img/biaoqian2@2x.png" alt="装饰"> -->
            </div>
            <div class="disclaimer-content">
                第三方服务机构对社会数据资产的合规性、真实性及权利归属情况进行实质性审查，对其出具的审查报告自行承担全部法律责任。AI数字资产确权中心仅对登记主体提交的社会数据资产申请材料进行形式审查。因社会数据资产的合规性、真实性、权属争议或第三方服务机构审查报告产生的直接或间接法律后果，AI数字资产确权中心不承担任何法律责任。
            </div>
        </div>
    </div>
</template>
<script>
import { message } from 'ant-design-vue'

export default {
  name: 'ewmInfo',
  data() {
    return {
      certInfo: {}
    }
  },
  mounted() {
    this.getCertInfo()
  },
  methods: {
    async getCertInfo() {
      const key = this.$route.query.key
      if (!key) {
        message.error('缺少证书编号参数')
        return
      }
      
      try {
        const res = await this.request({ 
          method: "get", 
          url: "https://ai.iptzx.com/api/index/certInfo?key=" + key, 
          headers: { token: localStorage.getItem('token') }, 
          data: {} 
        })
        
        if (res.data.code === 1 && res.data.data) {
          this.certInfo = res.data.data
        } else {
          message.error(res.data.msg || '获取证书信息失败')
        }
      } catch (error) {
        console.error('获取证书信息失败:', error)
        message.error('获取证书信息失败，请稍后重试')
      }
    }
  }
}
</script>
<style scoped>
.header {
            background-color: #ffffff;
            padding: 12px 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: sticky;
            top: 0;
            z-index: 100;
        }

        .header-back {
            font-size: 24px;
            color: #333;
            cursor: pointer;
        }

        .header-title {
            font-size: 17px;
            font-weight: 600;
            color: #333;
        }

        .header-menu {
            font-size: 20px;
            color: #333;
            cursor: pointer;
        }

        .main-content {
            padding: 20px 16px;
        }

        .page-title {
            text-align: center;
            margin-bottom: 16px;
        }

        .page-title h1 {
            font-size: 24px;
            font-weight: 600;
            color: #333;
            margin-bottom: 0px;
        }

        .page-title p {
            font-size: 10px;
            color: #666;
            letter-spacing: 0.5px;
        }

        .success-icon {
            text-align: center;
            margin: 5px 0;
        }

        .success-icon img {
            width: 50px;
            height: auto;
        }

        .success-text {
            text-align: center;
            font-size: 17px;
            font-weight: 600;
            color: #333;
            margin-bottom: 36px;
            color: #31BC69;
        }

        .certificate-header {
            position: relative;
        }

        .certificate-header img {
            /* width: 100%; */
            height: 50px;
            display: block;
            margin: auto;
            margin-top: -28px;
            margin-bottom: 30px;
        }

        .certificate-header-text {
            text-align: center;
            font-size: 20px;
            font-weight: 600;
            color: #1A1A1A;
            margin-bottom: 20px;
        }

        .certificate-card {
            /* background-color: #fff; */
            background: #F8F8F8;
            border-radius: 5px;
            padding: 18px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
        }

        .info-item {
            margin-bottom: 20px;
        }

        .info-label {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            font-size: 13px;
            color: #0F6DF4;
        }

        .info-label img {
            width: 8px;
            height: auto;
            margin-right: 8px;
        }

        .info-value {
            /* background-color: #f8f9fa; */
            background-color: #fff;
            border-radius: 8px;
            padding: 12px 16px;
            font-size: 14px;
            color: #333;
            min-height: 44px;
            word-break: break-all;
        }

        .disclaimer-section {
            margin-top: 30px;
            text-align: center;
        }

        .disclaimer-title {
            /* display: inline-flex; */
            align-items: center;
            font-size: 16px;
            color: #1A1A1A;
            margin-bottom: 12px;
            background: url(../../assets/biaoqian2@2x.png) center center no-repeat;
            background-size: auto 100%;
            font-weight: 400;
        }

        .disclaimer-title img {
            width: 40px;
            height: auto;
            margin: 0 8px;
        }

        .disclaimer-content {
            background-color: #fff;
            border-radius: 12px;
            padding: 0 16px;
            font-size: 12px;
            color: #979797;
            line-height: 1.6;
            text-align: left;
        }
</style>
